import { render, staticRenderFns } from "./CompilationDescription.vue?vue&type=template&id=32fcc6c7&scoped=true&"
import script from "./CompilationDescription.vue?vue&type=script&lang=js&"
export * from "./CompilationDescription.vue?vue&type=script&lang=js&"
import style0 from "./CompilationDescription.vue?vue&type=style&index=0&id=32fcc6c7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fcc6c7",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CompilationQr: require('/home/bitrix/frontend/components/compilations/CompilationQr.vue').default,CompilationTextAndBtns: require('/home/bitrix/frontend/components/compilations/CompilationTextAndBtns.vue').default})
